module.exports = __webpack_public_path__ + "static/media/code1.a8d12b81.jpg";